import { useMemo } from "react";

export default function useColumnsSupplierCurrentAccount() {
 const columns = useMemo(
   () => [
     {
       Header: "ID",
       accessor: "id"
     },
     {
       Header: "Fecha",
       accessor: "formatDate"
     },
     {
       Header: "Fecha",
       accessor: "date"
     },
     {
       Header: "N° de comprobante",
       accessor: "invoiceNumber"
     },
     {
       Header: "Tipo de comprobante",
       accessor: "invoiceLetter"
     },
     {
       Header: "Importe",
       accessor: "price"
     },
     {
       Header: "Pagado",
       accessor: "totalPaid"
     },
     {
       Header: "Saldo",
       accessor: "balance"
     },
     {
       Header: "isInvoice",
       accessor: "isInvoice"
     }
   ],
   []
 );

 return columns;
}